import { IOverview } from "../../services/interface/IDemand";
import { formatter } from "../../utils/formatter";

type Props = { card: IOverview };

const getTitleFromKey = (key: string): string => {
    switch (key) {
        case "dcAccuracy":
            return "DC Accuracy";
        case "storeAccuracy":
            return "Store Accuracy";
        case "dcBias":
            return "DC Bias";
        case "storeBias":
            return "Store Bias";
        case "avgForecast":
            return "Forecast";
        case "actualAvg":
            return "Actual";
        case "avgActual":
            return "Actual";
        case "avgForecastNext5week":
            return "Avg Forecast Next 5 Weeks";
        case "forecastDemand":
            return "Forecast Demand"
        default:
            return key;
    }
};

export const OverviewCard = ({ card }: Props) => {
    return (
        <div className="bg-white shadow-module-card p-[0.6vw] h-full w-[15.5vw] rounded 
            border-[#BEBEBE] border
            flex flex-col justify-between cursor-pointer">
            <p className="info-card-title font-semibold">{getTitleFromKey(card.key)}</p>
            {typeof card?.value === "number" && <div className="flex flex-col">
                <span className={`info-card-title-value font-normal leading-[1.2] ${card?.className ? card?.className : "text-deloitteGreen"}`}>
                    {!card?.isAbsolute ? Number(card?.value * 100).toFixed(2)+"%" : formatter(card?.value)}
                </span>
                <span className="text-fs16">{card?.target ? `Target ${formatter(card?.target)}` : ""}</span>
                {["Forecast Demand"].includes(getTitleFromKey(card.key))  ? <span className="text-fs16">Avg of Next 5 Weeks</span> : <></>}
            </div>}
            {Array.isArray(card?.value) && Array(card?.value).map((value,index) => {
                return <div className="grid grid-cols-2" key={index}>
                    <div className="flex flex-col">
                        <span className={`info-card-title-value font-normal text-deloitteGreen`}>{formatter(value[0].value)}</span>
                        <span className="text-fs18">{getTitleFromKey(value[0].key)}</span>
                    </div>
                    <div className="flex flex-col">
                        <span className={`info-card-title-value font-normal text-deloitteGreen`}>{formatter(value[1].value)}</span>
                        <span className="text-fs18">{getTitleFromKey(value[1].key)}</span>
                    </div>
                </div>
            })}
        </div>
    );
};
